import { RootState } from '@/app/store';

export const selectMinesStatus = (s: RootState) => s.mines.status;
export const selectMinesGame = (s: RootState) => s.mines.game;
export const selectMinesResult = (s: RootState) => s.mines.result;
export const selectMinesPendingCell = (s: RootState) => s.mines.pendingCell;
export const selectMinesLoading = (s: RootState) => s.mines.loading;
export const selectMinesRadarHint = (s: RootState) => s.mines.radarHint;
